module.exports = __webpack_public_path__ + "static/media/xenonstack-downarrow.be9e129a.svg";